// eslint-disable-next-line import/no-cycle
import { MappedBillingDocument } from '../accounts/types';

export type ZatcaMessageCategory =
  | 'INVOICE_ERRORS' // invoice hash or invoice missing
  | 'XSD_SCHEMA_ERROR' // XML UBL 2.1 standards
  | 'EN_KSA_ERRORS' // XML rules error
  | 'Authentication-Errors' // Certificate unauthorized
  | 'HTTP-Errors' // 500
  | 'QR_CODE_ERROR';

export type ZatcaMessageType = 'INFO' | 'ERROR' | 'WARNING';

export interface ZatcaMessage {
  type: ZatcaMessageType;
  code: string;
  status: string;
  category: ZatcaMessageCategory;
  message: string;
}

export interface CbCreditNoteData {
  cn_id: string;
  cn_reason_code?: string;
  cn_create_reason_code?: string;
  cn_date?: number;
  cn_total?: number;
  cn_status: string;
}

export enum InvoiceZatcaStatusConstantOnFE {
  Pending = 'Pending',
  Accepted = 'Accepted',
  AcceptedWithWarnings = 'AcceptedWithWarnings',
  Rejected = 'Rejected',
  NotSubmitted = 'NotSubmitted',
  WaitingOnStatus = 'WaitingOnStatus',
  Failed = 'Failed',
  PreZatca = 'Pre ZATCA',
}

export enum InvoiceZatcaStatusConstantKeyToText {
  Pending = 'Pending',
  Accepted = 'Accepted',
  AcceptedWithWarnings = 'Accepted with Warnings',
  Rejected = 'Rejected',
  NotSubmitted = 'Not submitted',
  WaitingOnStatus = 'Waiting on status',
  Failed = 'Failed',
  ['Pre ZATCA'] = 'Pre ZATCA',
}

export enum InvoiceZatcaType {
  B2B = 'B2B',
  B2C = 'B2C',
}

export interface PartialDocument {
  email: string;
  type: string;
  id: string;
  zatcaError: ZatcaMessage[];
}

export interface ReSubmitToZatcaInput {
  dialogVisible: boolean;
  wholeInvoice: boolean;
  document?: MappedBillingDocument | PartialDocument;
}
